const translations = {
    motors: 'Motors',
    nozzles: 'Nozzles',
    props: 'Props',
    pumps: 'Pumps'
};

export default translations;
